module.exports = __webpack_public_path__ + "img/free05_800x400.56acefeb.jpg";